export default function OffIcon({ className }) {
    return (
        <svg version="1.1" className={className} id="fi_503863" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" enableBackground="enable-background:new 0 0 512 512" xmlSpace="preserve">
            <g>
                <g>
                    <path d="M138.667,160c-52.928,0-96,43.072-96,96s43.072,96,96,96c52.928,0,96-43.072,96-96S191.595,160,138.667,160z"></path>
                </g>
            </g>
            <g>
                <g>
                    <path d="M373.333,117.333H138.667C62.208,117.333,0,179.541,0,256s62.208,138.667,138.667,138.667h234.667
			C449.792,394.667,512,332.459,512,256S449.792,117.333,373.333,117.333z M373.333,373.333H138.667
			c-64.683,0-117.333-52.629-117.333-117.333s52.651-117.333,117.333-117.333h234.667c64.683,0,117.333,52.629,117.333,117.333
			S438.016,373.333,373.333,373.333z"></path>
                </g>
            </g>
            <g>
                <g>
                    <path d="M288,202.667c-17.643,0-32,14.357-32,32v42.667c0,17.643,14.357,32,32,32s32-14.357,32-32v-42.667
			C320,217.024,305.643,202.667,288,202.667z M298.667,277.333c0,5.888-4.8,10.667-10.667,10.667s-10.667-4.779-10.667-10.667
			v-42.667c0-5.888,4.8-10.667,10.667-10.667s10.667,4.779,10.667,10.667V277.333z"></path>
                </g>
            </g>
            <g>
                <g>
                    <path d="M384,202.667h-32c-5.888,0-10.667,4.779-10.667,10.667v85.333c0,5.888,4.779,10.667,10.667,10.667
			c5.888,0,10.667-4.779,10.667-10.667V224H384c5.888,0,10.667-4.779,10.667-10.667S389.888,202.667,384,202.667z"></path>
                </g>
            </g>
            <g>
                <g>
                    <path d="M373.333,245.333H352c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667h21.333
			c5.888,0,10.667-4.779,10.667-10.667S379.221,245.333,373.333,245.333z"></path>
                </g>
            </g>
            <g>
                <g>
                    <path d="M448,202.667h-32c-5.888,0-10.667,4.779-10.667,10.667v85.333c0,5.888,4.779,10.667,10.667,10.667
			c5.888,0,10.667-4.779,10.667-10.667V224H448c5.888,0,10.667-4.779,10.667-10.667S453.888,202.667,448,202.667z"></path>
                </g>
            </g>
            <g>
                <g>
                    <path d="M437.333,245.333H416c-5.888,0-10.667,4.779-10.667,10.667s4.779,10.667,10.667,10.667h21.333
			c5.888,0,10.667-4.779,10.667-10.667S443.221,245.333,437.333,245.333z"></path>
                </g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
            <g>
            </g>
        </svg>
    )
}